export const isPromiseLike = <T = unknown>(
  value: unknown,
): value is PromiseLike<T> => {
  const promiseLike =
    (typeof value === 'object' || typeof value === 'function') &&
    value !== null &&
    typeof (value as PromiseLike<T>).then === 'function'
  return promiseLike
}
